import { ArrowLeft2 } from 'iconsax-react'

import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'

import { Button } from '../ui/button'

import type { BackHeaderTypes } from './BackHeader.types'

export const BackHeader = ({
  backText,
  onPressBack,
  buttonStyles,
}: BackHeaderTypes) => {
  return (
    <div className="flex flex-row">
      <Button
        asChild
        size={'icon'}
        className={
          buttonStyles
            ? `${buttonStyles}`
            : 'bg-baseColorHighlight rounded-full mr-4 hover:bg-primaryColor hover:border-primaryColor'
        }
        variant={'ghost'}
        onClick={onPressBack}
      >
        <div>
          <ArrowLeft2 color={SocialMirrorPalette.neutralColor} />
        </div>
      </Button>

      {backText && (
        <div className="flex justify-center items-center">
          <h1 className="text-neutralColor text-2xl font-semibold tracking-wide">
            {backText}
          </h1>
        </div>
      )}
    </div>
  )
}
